import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getDashboardPathForRole } from "../utils/authRole";
import { getStoredAuthSnapshot } from "../utils/sessionManager";

const Unauthorized = () => {
  const location = useLocation();
  const message = location.state?.message || "You are not authorized to access this page.";
  const dashboardPath = getDashboardPathForRole(getStoredAuthSnapshot().role);

  return (
    <div className="mx-auto mt-12 max-w-2xl rounded-3xl border border-rose-200 bg-white px-6 py-10 text-center shadow-lg shadow-rose-100/50">
      <p className="text-xs font-semibold uppercase tracking-[0.24em] text-rose-500">
        Access blocked
      </p>
      <h1 className="mt-3 text-3xl font-extrabold text-slate-900">
        Permission required
      </h1>
      <p className="mt-4 text-base leading-7 text-slate-600">
        {message}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to={dashboardPath === "/" ? "/" : dashboardPath}
          className="inline-flex items-center rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800"
        >
          Return to dashboard
        </Link>
        <Link
          to="/profile"
          className="inline-flex items-center rounded-full border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
        >
          Review account
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;
